import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HexBase64BinaryEncoding } from 'crypto';

@Component({
  selector: 'app-base64-to-image',
  templateUrl: './base64-to-image.component.html',
  styleUrls: ['./base64-to-image.component.scss']
})
export class Base64ToImageComponent implements OnInit {
  @Input('imageSource') image: HexBase64BinaryEncoding;
  imageSource;
  imageNull: boolean = false;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.imageNull = this.image == null ? !this.imageNull : this.imageNull
    this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${this.image}`);
  }
}
